import React from "react";
import { LaunchModal } from "MODULES/shared/components";
import Modal from "./Modal";

export default function New({ quote }) {
  return (
    <LaunchModal
      modal={props => <Modal {...props} quote={quote} />}
      buttonClass="btn-primary btn-hollow pull-right"
      text="Add Parts To Quote"
    />
  );
}



// WEBPACK FOOTER //
// ./app/modules/OutgoingQuotes/Detail/LineItems/Create/Create.jsx